// In single-spa, the assets need to be loaded from a dynamic location,
// instead of hard coded to `/assets`. We use webpack public path for this.
// See https://webpack.js.org/guides/public-path/#root

import { Directive, ElementRef, inject } from '@angular/core';

export function assetUrl(url: string): string | undefined {
  if (!url) {
    return;
  }

  if (url.startsWith('data:') || url.startsWith('https://')) {
    return url;
  }

  const cleanUrl = url.replace(/^\/?assets\//, '');
  const urlPrefix = cleanUrl.startsWith('/') ? '' : '/';

  if (!(window as any).singleSpaNavigate) {
    return `/assets${urlPrefix}${cleanUrl}`;
  }
  // @ts-ignore
  const publicPath = __webpack_public_path__;
  const publicPathSuffix = publicPath.endsWith('/') ? '' : '/';

  return `${publicPath}${publicPathSuffix}assets${urlPrefix}${cleanUrl}`;
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'img[src]'
})
export class RewriteAssetUrlDirective {
  private readonly el = inject(ElementRef<HTMLImageElement>);
  constructor() {
    if (!(window as any).singleSpaNavigate) {
      return;
    }
    const src = this.el.nativeElement.getAttribute('src');

    if (src && !src.startsWith('http')) {
      this.el.nativeElement.src = assetUrl(src);
    }
  }
}
